import {  Button,  FormControl, GridIcon,  ListIcon, RequiredValidator, SearchIcon, Textarea, ToggleButtonGroup } from '@keplerco/core';
import React, { useState } from 'react';

import styles from './roles.module.css';
import { useForm } from 'react-hook-form';
import { RoleDto } from '../../apis';
import { DefaultOptions, useApis } from '../../global-state';
import { EmptyState } from '../../components/empty-state/empty-state';
import { RoleSearchRequest, ViewType } from './roles.models';
import { RolesLayoutGrid, RolesLayoutList } from './roles.layout';
interface IFormValues {
  rolePrompt: string;
}

export function RolesAdvancedLayout(): JSX.Element {
  const [activeViewType, setActiveViewType] = useState<ViewType>('Grid');
  const [loading, setLoading] = useState<boolean>(true);
  const [searched, setSearched] = useState<boolean>(false);
  const [request, setRequest] = useState<RoleSearchRequest>({
    search: undefined,
    category: undefined,
    pageSize: 6,
    page: 1
  });

  const { roleApi } = useApis();
  const [data, setData] = useState<Array<RoleDto>>();
  const { handleSubmit, control, setValue } = useForm<any>({ mode: 'onChange' });
  async function onSubmitHandler(values: IFormValues) {
    setLoading(true);
    setSearched(true)
    const rolesData = await roleApi.roleSuggestGet(values.rolePrompt, DefaultOptions);
    setData(rolesData);
    setLoading(false);
  }
  return (
    <div className={styles.rolesContainer}>
      <span className="caption1">Can't find your role? Tell us about your interests and we'll help you find it.</span>
      {!searched &&
        <form id="search-roles" onSubmit={handleSubmit(onSubmitHandler)}>
          <div className="dialogBodyLayout">
            <div className="card" style={{ position: 'relative', marginBottom: 30 }}>
              <div className="row">
                <div className="column">
                  <FormControl
                    control={control}
                    rules={new RequiredValidator('Enter a description')}
                    name="rolePrompt"
                    render={({ field, fieldState }) => {
                      return <Textarea {...field} haserror={!!fieldState.error} label="Tell us about the role you're interested in" responsive />;
                    }}
                  />
                </div>
              </div>
              <Button
                fullWidthMobile
                type="button"
                square
                theme="dark"
              >
                <div style={{ display: 'flex', gap: 15, alignItems: 'center', justifyContent: 'center' }}>
                  Search
                  <SearchIcon />
                </div>
              </Button>
            </div>
          </div>
        </form>}
      {searched &&
        <>
          <div className={styles.rolesActions}>
            <Button
              fullWidthMobile
              type="button"
              square
              theme="dark"
              onClick={() => {
                setSearched(false);
                setData([])
              }}
            >
              <div style={{ display: 'flex', gap: 15, alignItems: 'center', width: 200 }}>
                Search again  <SearchIcon />
              </div>
            </Button>
            <div className={styles.rolesActionsGroup}>
              <ToggleButtonGroup
                buttons={[
                  { label: 'Grid', icon: <GridIcon /> },
                  { label: 'List', icon: <ListIcon /> },
                ]}
                defaultButtonLabel={activeViewType}
                onClick={buttonLabel => setActiveViewType(buttonLabel as ViewType)}
              />
            </div>
          </div>

          {(loading || !!data?.length) ? (
            <React.Fragment>
              {activeViewType === 'Grid' ? (
                <RolesLayoutGrid
                  loading={loading}
                  data={data}
                />
              ) : (
                <RolesLayoutList
                  loading={loading}
                  setRequest={setRequest}
                  data={data}
                />
              )}
            </React.Fragment>
          ) : (
            <EmptyState title="No roles found" />
          )}
        </>
      }
    </div>
  );
}